module.exports = __webpack_public_path__ + "img/box-arrow-down.4ca910e9.svg";